// src/lib/billingMode.js
import { Capacitor } from '@capacitor/core';

// Named export so you can: import { billingMode } from "@/lib/billingMode"
export function billingMode() {
  try {
    // Returns 'native' on iOS/Android (Capacitor build), otherwise 'web'
    return Capacitor.isNativePlatform && Capacitor.isNativePlatform() ? 'native' : 'web';
  } catch {
    return 'web';
  }
}

// Also export default for flexibility (optional)
export default billingMode;
